function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "m75 512c-3.835938 0-7.675781-1.464844-10.605469-4.394531-5.859375-5.859375-5.859375-15.351563 0-21.210938l30-30c5.859375-5.859375 15.351563-5.859375 21.210938 0s5.859375 15.351563 0 21.210938l-30 30c-2.929688 2.929687-6.765625 4.394531-10.605469 4.394531zm0 0",
  fill: "#465a61"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "m437 512c-3.835938 0-7.675781-1.464844-10.605469-4.394531l-30-30c-5.859375-5.859375-5.859375-15.351563 0-21.210938s15.351563-5.859375 21.210938 0l30 30c5.859375 5.859375 5.859375 15.351563 0 21.210938-2.929688 2.929687-6.765625 4.394531-10.605469 4.394531zm0 0",
  fill: "#3b4a51"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "m326.5 25.5-90 90c-2.699219 3-6.601562 4.5-10.5 4.5s-7.800781-1.5-10.5-4.5l-90-90c-6-5.699219-6-15.300781 0-21 5.699219-6 15.300781-6 21 0l79.5 79.199219s0 0 .300781-.300781l79.199219-78.898438c5.699219-6 15.296875-6 21 0 6 5.699219 6 15.300781 0 21zm0 0",
  fill: "#465a61"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "m236.5 115.5c-2.699219 3-6.601562 4.5-10.5 4.5v-36.300781s0 0 .300781-.300781l79.199219-78.898438c5.699219-6 15.296875-6 21 0 6 5.699219 6 15.300781 0 21zm0 0",
  fill: "#3b4a51"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  d: "m467 90h-422c-24.902344 0-45 20.097656-45 45v302c0 24.898438 20.097656 45 45 45h422c24.902344 0 45-20.101562 45-45v-302c0-24.902344-20.097656-45-45-45zm0 0",
  fill: "#e63950"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  d: "m512 135v302c0 24.898438-20.097656 45-45 45h-241v-392h241c24.902344 0 45 20.097656 45 45zm0 0",
  fill: "#cc2e43"
});

var _ref8 =
/*#__PURE__*/
React.createElement("path", {
  d: "m317 150h-212c-24.902344 0-45 20.097656-45 45v182c0 24.898438 20.097656 45 45 45h212c24.902344 0 45-20.101562 45-45v-182c0-24.902344-20.097656-45-45-45zm0 0",
  fill: "#c6e2e7"
});

var _ref9 =
/*#__PURE__*/
React.createElement("path", {
  d: "m422 225c-16.539062 0-30-13.460938-30-30s13.460938-30 30-30 30 13.460938 30 30-13.460938 30-30 30zm0 0",
  fill: "#c6e2e7"
});

var _ref10 =
/*#__PURE__*/
React.createElement("g", {
  fill: "#465a61"
}, React.createElement("path", {
  d: "m437 285h-30c-8.289062 0-15-6.707031-15-15 0-8.289062 6.710938-15 15-15h30c8.292969 0 15 6.710938 15 15 0 8.292969-6.707031 15-15 15zm0 0"
}), React.createElement("path", {
  d: "m437 347h-30c-8.289062 0-15-6.707031-15-15 0-8.289062 6.710938-15 15-15h30c8.292969 0 15 6.710938 15 15 0 8.292969-6.707031 15-15 15zm0 0"
}), React.createElement("path", {
  d: "m437 407h-30c-8.289062 0-15-6.707031-15-15 0-8.289062 6.710938-15 15-15h30c8.292969 0 15 6.710938 15 15 0 8.292969-6.707031 15-15 15zm0 0"
}));

var _ref11 =
/*#__PURE__*/
React.createElement("path", {
  d: "m362 195v182c0 24.898438-20.097656 45-45 45h-91v-272h91c24.902344 0 45 20.097656 45 45zm0 0",
  fill: "#a8d3d8"
});

var SvgTv = function SvgTv(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    height: "512pt",
    viewBox: "0 0 512 512.00025",
    width: "512pt",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgTv, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/tv.d10b4237.svg";
export { ForwardRef as ReactComponent };